import { Handle, Position } from "reactflow";
import { BarsOutlined } from "@ant-design/icons";

import { ButtonDelete } from "../../ButtonDelete";
import { useFlowNodes } from "../../../context";
import Events from "components/Accordion/AccordionIntents/inputs/events";
import { handleDeleteEventNode } from "../../utils/removeDataNode";

import "./EventIntentNode.scss";

export const EventIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, contexts, ...res } = useFlowNodes();
  return (
    <div className="event-node">
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="event-header">
        <div className="event-title">
          <div className="event-icon">
            <BarsOutlined />
          </div>
          <span className="event-name">
            {t("common:intents.flow_chat.event.title")}
          </span>
        </div>
        <span className="event-add-button">
          <ButtonDelete
            setNodes={setNodes}
            setEdges={setEdges}
            nodeId={id}
            handleDelete={() => handleDeleteEventNode(res.updateIntent)}
          />
        </span>
      </div>
      <div className={"accordion__content"}>
        <Events {...{ t, ...res }} isFlow={true} />
      </div>
    </div>
  );
};
